module.exports = {
  API_BASE_URL: 'https://api.purchease.com',
  S3_PROXY_BASE_URL: 'https://s3-proxy-web.purchease.com',
  LOG_LEVEL: 2,
  UAT_MODE: true,
}
